
import { useState, useEffect, useCallback } from 'react';
import { getTickets, SupportTicket } from '@/utils/supportTicketService';
import { UserRole } from '@/types/userRole';
import { getCurrentUser } from '@/utils/auth';

export const useTickets = () => {
  const [tickets, setTickets] = useState<SupportTicket[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  
  const user = getCurrentUser();
  const userRole = user?.role as UserRole || 'user';
  
  const fetchTickets = useCallback(async () => {
    try {
      setIsLoading(true);
      const data = await getTickets(userRole);
      setTickets(data);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to fetch tickets'));
      console.error('Error fetching tickets:', err);
    } finally {
      setIsLoading(false);
    }
  }, [userRole]);
  
  useEffect(() => {
    fetchTickets();
  }, [fetchTickets]);
  
  const refreshTickets = useCallback(async () => {
    await fetchTickets();
  }, [fetchTickets]);
  
  return {
    tickets,
    isLoading,
    error,
    refreshTickets
  };
};
